import Snackbar from '@mui/material/Snackbar';
import { COLLABORATOR_SYNC_ERROR_SNACKBAR_ID, useCollaboratorSyncError } from './collaboratorSyncErrorNotification';
import { useMeasuredBottomSnackbarStackIndex } from './SnackbarStackContext';
import { bottomCenterSnackbarStackSx, centeredPlainSnackbarContentSx, mergeSx } from './snackbarStyles';

interface CollaboratorSyncErrorSnackbarProps {
  stackIndex?: number;
}

const CollaboratorSyncErrorSnackbar = ({ stackIndex: stackIndexOverride }: CollaboratorSyncErrorSnackbarProps) => {
  const syncError = useCollaboratorSyncError();
  const open = Boolean(syncError);
  const { ref: snackbarRef, stackIndex: registeredStackIndex } = useMeasuredBottomSnackbarStackIndex<HTMLDivElement>({
    disabled: stackIndexOverride !== undefined,
    horizontal: 'center',
    open,
  });
  const stackIndex = stackIndexOverride ?? registeredStackIndex;

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      ref={snackbarRef}
      open={open}
      message={syncError}
      sx={bottomCenterSnackbarStackSx(stackIndex)}
      slotProps={{
        content: {
          id: COLLABORATOR_SYNC_ERROR_SNACKBAR_ID,
          role: 'alert',
          sx: mergeSx(centeredPlainSnackbarContentSx, (theme) => ({
            maxWidth: 320,
            backgroundColor: theme.vars?.palette?.background?.paper ?? theme.palette.background.paper,
            color: theme.vars?.palette?.error?.main ?? theme.palette.error.main,
          })),
        },
      }}
    />
  );
};

export default CollaboratorSyncErrorSnackbar;
